import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Grid = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Grid" {...props}>
    <path d="M21 16.5H16.5V21H18C19.6569 21 21 19.6569 21 18V16.5ZM9.5 21H14.5V16.5H9.5V21ZM16.5 14.5H21V9.5H16.5V14.5ZM9.5 14.5H14.5V9.5H9.5V14.5ZM3 14.5H7.5V9.5H3V14.5ZM9.5 7.5H14.5V3H9.5V7.5ZM3 18C3 19.6569 4.34315 21 6 21H7.5V16.5H3V18ZM21 6C21 4.34315 19.6569 3 18 3H16.5V7.5H21V6ZM3 7.5H7.5V3H6C4.34315 3 3 4.34315 3 6V7.5ZM23 18C23 20.7614 20.7614 23 18 23H6C3.23858 23 1 20.7614 1 18V6C1 3.23858 3.23858 1 6 1H18C20.7614 1 23 3.23858 23 6V18Z" fill="#000"/>
  </StyledIcon>
));

Grid.displayName = 'Grid';

export { Grid };
